import React, { useState } from "react";
import "../Styles/UserResponse.css";
import "../Styles/Form/Responces.css";
import {
  CheckBox,
  CheckBoxGrid,
  DateAndTime,
  DateQuestion,
  Dropdown,
  Email,
  FileUpload,
  VAFileUpload,
  GridBox,
  LineScale,
  MultipleChoice,
  Name,
  Number,
  ParagraphAnswer,
  Phone,
  Ratings,
  ShortAnswer,
  Signature,
  Spinner,
  Website,
} from "../Components/Form/UserResponse/UserResponseComponents";
import { useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { updateResponse } from "../Redux/Reducer/ResponseSlices";

const userResponsePage = {
  formTitle: "",
  formDescription: "",
  sections: [
    {
      sectionTitle: "Surveyor Form",
      sectionDescription:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti? Lorem ipsum dolor sit amet consect",
      questions: [
        {
          question:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ",
          minRange: { value: 0, labelName: "Stephen" },
          maxRange: { value: 5, labelName: "Lorem Ipsum" },
          type: "Line Scale",
        },
        {
          question:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ",
          type: "Short Answer",
          placeHolder: "Short Answer",
        },
        {
          question:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam dffffjnjewr",
          type: "Paragraph",
          placeHolder: "Short Answer",
        },
        {
          question:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti?",
          options: [
            { optionText: "Chennai" },
            { optionText: "Erode" },
            { optionText: "Coimbatore" },
            { optionText: "Madurai" },
          ],
          type: "Multiple Choice",
        },
        {
          question:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti,",
          selectedOptions: ["Chennai", "Coimbatore"],
          type: "Check box",
          options: [
            { optionText: "Chennai" },
            { optionText: "Erode" },
            { optionText: "Coimbatore" },
            { optionText: "Madurai" },
          ],
        },
        {
          question:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti",
          row: [
            { rowText: "Row 1" },
            { rowText: "Row 2" },
            { rowText: "Row 3" },
            { rowText: "Row 3" },
          ],
          type: "Multiple Choice grid",
          column: [
            { columnText: "COlumn 1" },
            { columnText: "Column 2" },
            { columnText: "Column 3" },
            { columnText: "Column 4" },
          ],
          selectedAnswer: [],
        },
        {
          question:
            "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti",
          row: [
            { rowText: "Row 1" },
            { rowText: "Row 2" },
            { rowText: "Row 3" },
            { rowText: "Row 3" },
          ],
          type: "Check box grid",
          column: [
            { columnText: "COlumn 1" },
            { columnText: "Column 2" },
            { columnText: "Column 3" },
            { columnText: "Column 4" },
          ],
          selectedAnswer: [
            [1, 3],
            [0, 2],
            [2, 3],
            [0, 3],
          ],
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          placeHolder: "Phone ( International )",
          type: "Phone",
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          type: "Name",
          firstNamePlaceHolder: "First Name",
          lastNamePlaceHolder: "Last Name",
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          type: "Website",
          placeHolder: "example website.com or .in",
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          type: "Email",
          placeHolder: "Example@gmail.com",
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          placeHolder: "Phone ( International )",
          type: "Number",
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          type: "Spinner",
          answer: 0,
        },
        // {
        //   question:
        //     "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
        //   placeHolder: "Phone ( International )",
        //   boxWidth: "400", // Ensure these values are strings or numbers
        //   boxHeight: "200",
        //   type: "Signature",
        //   answer: { signature: sample_signer_image },
        // },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s ",
          type: "File Upload",
          answer: { file: "HannahBusing_Resume.pdf" },
          fileSizeMin: "0MB",
          fileSizeMax: "10Mb",
          NoOfNumFile: 2,
          fileTypes: "pdf, doc, jpeg",
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s ",
          type: "Date",
          answer: { date: "10/Apr/2024" },
          autofillDate: true,
          required: false,
          dateFormat: "YYYY/MM/DD",
        },
        {
          question: "Lorem Ipsum has been the industry's standard dumm",
          answer: { rating: 7 },
          typeofdign: "heart",
          type: "Ratings",
          count: 10,
        },
        {
          question: "Lorem Ipsum has been the industry's standard dumm",
          type: "Dropdown",
          options: [
            { label: "Chennai Outer", value: "Chennai Outer" },
            { label: "Chennai", value: "Chennai" },
            { label: "Madurai", value: "Madurai" },
            { label: "Karur", value: "Karur" },
          ],
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s ",
          answer: {
            date: "10/Apr/2024",
            time: "06:40:PM",
          },
          type: "Date - Time",
        },
      ],
    },
    {
      sectionTitle: "Surveyor Form",
      sectionDescription:
        "Lorem ipsum dolor sit amet consectetur adipisicing elit. Veniam itaque quam ab illo facere, nemo quas, eaque velit iste corrupti, neque sequi quia odit. Soluta laudantium consequatur magni porro corrupti? Lorem ipsum dolor sit amet consect",
      questions: [
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          placeHolder: "Phone ( International )",
          type: "Phone",
        },
        {
          question:
            "Lorem Ipsum has been the industry's standard dummy text ever since the 1500s",
          type: "Name",
          firstNamePlaceHolder: "First Name",
          lastNamePlaceHolder: "Last Name",
        },
      ],
    },
  ],
};
const AddNewResponseTableView = ({ children }) => {
  const [question, setQuestion] = useState(null);
  const formId = useParams();

  const baseUrl = process.env.REACT_APP_API;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalSections, setTotalSection] = useState(0);
  const fetchForm = async () => {
    try {
      const response = await axios.get(`${baseUrl}/forms/${formId.formId}`);
      setQuestion(response.data);
      setTotalSection(response.data.sections.length);
    } catch (error) {
      console.log(error);
      console.error("Error fetching form:", error);
    }
  };
  useEffect(() => {
    fetchForm();
  }, []);

  // const handleSelectChange = (event) => {
  //   setCurrentIndex(Number(event.target.value));
  // };

  const handleBack = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    if (currentIndex < totalSections - 1) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const responses = useSelector((state) => state.responses.responses);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getAnswerValue = (questionId) => {
    const response = responses.responses.find(
      (response) => response.questionId === questionId
    );
    return response ? response.answer : "";
  };

  const handleInputChange = (
    questionId,
    value,
    isMultipleChoice = false,
    isGrid = false,
    rowId = null
  ) => {
    dispatch(
      updateResponse({ questionId, value, isMultipleChoice, isGrid, rowId })
    );
  };

  const handelSubmitForm = async () => {
    if (formId.insertOrder) {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}/forms/${formId.formId}/addResponses/${formId.insertOrder}`,
          responses
        );
        if (response.data.status) {
          navigate(-1);
        }
      } catch (error) {
        console.error(error);
      }
    } else {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}/forms/${formId.formId}`,
          responses
        );
        navigate(-1);
      } catch (error) {
        console.log(error);
      }
    }

    console.log("furm submited", responses.responses);
  };

  if (!question) return <p>Loading form...</p>;
  return (
    <div className="user_Response_container">
      {/* {question.sections.map((section, index) => ( */}
      <Container section={question.sections[currentIndex]}>
        {question.sections[currentIndex].questions.map(
          (eachQuestion, qindex) => (
            <div key={qindex}>
              <AllQuestions
                eachQuestion={eachQuestion}
                index={qindex}
                section={question.sections[currentIndex]}
                getAnswerValue={getAnswerValue}
                handleInputChange={handleInputChange}
              />
            </div>
          )
        )}
      </Container>
      {/* ))} */}
      <div className="response_final_stage">
        <div>Clear form</div>
        <div className="btn_container">
          {currentIndex === totalSections - 1 && (
            <div
              className="response_final_stage_btn"
              onClick={handelSubmitForm}
            >
              Submit
            </div>
          )}
          {currentIndex > 0 && (
            <div className="response_final_stage_btn" onClick={handleBack}>
              Back
            </div>
          )}
          {currentIndex < totalSections - 1 && (
            <div className="response_final_stage_btn" onClick={handleNext}>
              Next
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

const Container = ({ section, children }) => {
  return (
    <div className="user_from_container">
      <div className="topbar_container">
        <div
          className="individualview_title"
          dangerouslySetInnerHTML={{ __html: section.sectionTitle }}
        ></div>
        <div
          className="individualview_description"
          dangerouslySetInnerHTML={{ __html: section.sectionDescription }}
        >
          {/* {section.sectionDescription} */}
        </div>
      </div>
      {children}
    </div>
  );
};
const AllQuestions = ({
  eachQuestion,
  index,
  getAnswerValue,
  handleInputChange,
}) => {
  return (
    <div>
      {renderQuestions(eachQuestion, index, getAnswerValue, handleInputChange)}
    </div>
  );
};
const renderQuestions = (
  eachQuestion,
  index,
  getAnswerValue,
  handleInputChange
) => {
  switch (eachQuestion.type) {
    case "Short Answer":
      return (
        <ShortAnswer
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Paragraph":
      return (
        <ParagraphAnswer
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Multiple Choice":
      return (
        <MultipleChoice
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Check box":
      return (
        <CheckBox
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Multiple Choice grid":
      return (
        <GridBox
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Check box grid":
      return (
        <CheckBoxGrid
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Phone":
      return <Phone question={eachQuestion} index={index} />;
    case "Name":
      return <Name question={eachQuestion} index={index} />;
    case "Website":
      return (
        <Website
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Email":
      return (
        <Email
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    case "Number":
      return (
        <Number
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Spinner":
      return <Spinner question={eachQuestion} index={index} />;
    case "Signature":
      return (
        <Signature
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "File Upload":
      return <FileUpload question={eachQuestion} index={index} />;
    case "Audio/Video Upload":
      return <VAFileUpload question={eachQuestion} index={index} />;
    case "Date":
      return (
        <DateQuestion
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
        />
      );
    case "Date - Time":
      return <DateAndTime question={eachQuestion} index={index} />;
    case "Ratings":
      return <Ratings question={eachQuestion} index={index} />;
    case "Dropdown":
      return <Dropdown question={eachQuestion} index={index} />;
    case "Line Scale":
      return (
        <LineScale
          question={eachQuestion}
          index={index}
          getAnswerValue={getAnswerValue}
          handleInputChange={handleInputChange}
        />
      );
    // case "Multiple Choice Image":
    //   return <MultipleChoiceImage question={eachQuestion} index={index} />;
    default:
      return null;
  }
};
export default AddNewResponseTableView;
